import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const BORDER_GRADIENT = `linear-gradient(to right, ${colorsPalettes.midnight[600]}, ${colorsPalettes.carbon[250]}, ${colorsPalettes.carbon[50]})`;
const LOGO_GRADIENT = `conic-gradient(from 90deg, ${colorsPalettes.midnight[600]} 0deg, ${colorsPalettes.midnight[600]} 216deg, ${colorsPalettes.carbon[50]} 360deg)`;

const LOGO_SHAPE_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path fill-rule="evenodd" d="M7.5 15C3.3579 15 0 11.6421 0 7.5C0 3.3579 3.3579 0 7.5 0C11.6421 0 15 3.3579 15 7.5C15 11.6421 11.6421 15 7.5 15ZM9.88458 5.11542H5.11542V9.88458H9.88458V5.11542Z"/></svg>';
const LOGO_MASK = `url("data:image/svg+xml,${encodeURIComponent(LOGO_SHAPE_SVG)}") center / contain no-repeat`;

export const Wrapper = styled.button<{ isCollapsed: boolean }>`
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    width: ${({ isCollapsed }) => (isCollapsed ? "30px" : "100%")};
    height: 30px;
    padding: ${({ isCollapsed }) => (isCollapsed ? "0" : "7px 11px")};
    justify-content: ${({ isCollapsed }) => (isCollapsed ? "center" : "flex-start")};
    margin-top: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background: transparent;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: 4px;
        padding: 1px;
        background: ${BORDER_GRADIENT};
        -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        mask-composite: exclude;
        pointer-events: none;
    }

    &:hover {
        background: ${colorsPalettes.carbon[25]};
    }

    &:active {
        background: ${colorsPalettes.carbon[50]};
    }

    transition:
        width 200ms ease-in-out,
        padding 200ms ease-in-out,
        background 150ms ease-in-out;
    transition-delay: ${({ isCollapsed }) => (isCollapsed ? "250ms" : "0")};
`;

export const Logo = styled.span<{ isCollapsed: boolean }>`
    flex-shrink: 0;
    width: ${({ isCollapsed }) => (isCollapsed ? "18px" : "15px")};
    height: ${({ isCollapsed }) => (isCollapsed ? "18px" : "15px")};
    background: ${LOGO_GRADIENT};
    mask: ${LOGO_MASK};
`;

export const Label = styled.span<{ isCollapsed: boolean }>`
    ${setFontVariant("primaryItem", colorsPalettes.carbon[400])};
    white-space: nowrap;
    overflow: hidden;
    opacity: ${({ isCollapsed }) => (isCollapsed ? 0 : 1)};
    width: ${({ isCollapsed }) => (isCollapsed ? 0 : "auto")};
    transition:
        opacity 200ms ease-in-out,
        width 200ms ease-in-out;
    transition-delay: ${({ isCollapsed }) => (isCollapsed ? "200ms" : "0")};
`;
